<!-- Questionnaire -->

<div *ngIf="commonUtilty.isArrayIterable(_questionnaire)" class="m-t-20 m-b-60">
  
  <nz-table class="table-quest" [nzData]=[1,2,3] [nzScroll]="tableScrollOptions" [nzLoading]="!questionnaireMap"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th class="main" nzLeft="0px" nzWidth="500px" style="flex: 1;" >Question
        
        <nz-filter-trigger [nzDropdownMenu]="menu">
          <i nz-icon nzType="search" style="margin-left: 70em;" style="flex: 1;"></i>
        </nz-filter-trigger>
        </th>

        <ng-container *ngFor="let client of insuredClientList">
          <th
            *ngIf="questionnaireMap && questionnaireMap[client.id] && questionnaireMap[client.id].appliesToCd == 'CLIENT'" nzWidth="150px">
            <div class="quest-person">
              <div class="quest-person-avatar">
                <nz-avatar class="avatar" [nzSize]="'small'" nzIcon="user"></nz-avatar>
              </div>
              <strong class="quest-person-name">{{client | MMSClientData: 'fullName'}}</strong>
              <small> DOB: {{(client | MMSClientData: 'dateOfBirth') | date}}</small>
            </div>
          </th>
        </ng-container>

      </tr>
      <tr>
        <th nzLeft="0px" nzWidth="500px">Select all as</th>
        <ng-container *ngFor="let client of insuredClientList; let i = index;">
          <th
            *ngIf="questionnaireMap && questionnaireMap[client.id] && questionnaireMap[client.id].appliesToCd == 'CLIENT'" nzWidth="150px">
            <div>
              <!-- <nz-select class="quest-input-width" nzPlaceHolder="Select All" [(ngModel)]="questionnaireMap[client.id]['selectAllForClient']" (ngModelChange)="selectAllValueForGivenClient(client.id)">
                <nz-option nzValue="YES" nzLabel="Yes"></nz-option>
                <nz-option nzValue="NO" nzLabel="No"></nz-option>
              </nz-select> -->
              <nz-radio-group [(ngModel)]="questionnaireMap[client.id]['selectAllForClient']" (ngModelChange)="selectAllValueForGivenClient(client.id)">
                <label nz-radio nzValue="NO">No</label>
                <label nz-radio nzValue="YES">Yes</label>
              </nz-radio-group>
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>

    <tbody>

      <ng-container *ngFor="let questionMasterDO of listOfQuestionMasterCds; let questionMasterIndex = index">
        <tr class="questionsId">
          <ng-container
            *ngIf="questionMasterDO && questionMasterDO['questionMsgDOMap'] && questionMasterDO['questionMsgDOMap'][languageCd]; else questionNotFoundInLanguage">
            <td *ngIf="!!!questionMasterDO.leadingQuestionCd" nzLeft="0px" nzWidth="300px" [class.main]="!!!questionMasterDO.leadingQuestionCd"
             >

              <!-- For nested levels use: [style.paddingLeft.px]="nestedLevel*25" on the td -->

              {{!questionMasterDO.leadingQuestionCd? questionMasterDO['questionNumber']+'.' : ' → '}}
              <!-- previously used: ⇨ -->
              {{questionMasterDO['questionMsgDOMap'][languageCd].message || 'Technical Issue: Question Text Missing'}}
            </td>
            <td *ngIf="questionMasterDO.leadingQuestionCd && questionMasterDO.isSubQuestionVisible" nzLeft="0px" nzWidth="300px" [class.main]="!!!questionMasterDO.leadingQuestionCd"
            [class.sub]="questionMasterDO.leadingQuestionCd">
            <!-- For nested levels use: [style.paddingLeft.px]="nestedLevel*25" on the td -->

            {{!questionMasterDO.leadingQuestionCd? questionMasterDO['questionNumber']+'.' : ' → '}}
            <!-- previously used: ⇨ -->
            {{questionMasterDO['questionMsgDOMap'][languageCd].message || 'Technical Issue: Question Text Missing'}}
          </td>
          </ng-container>
          <ng-template #questionNotFoundInLanguage>
            <td nzLeft="0px" nzWidth="300px" class="main">
              <!-- {{questionMasterIndex + 1}}. {{questionMasterDO['questionMsgDOMap']['EN'].msg}} -->
              <!-- <pre>{{questionMasterDO | json}}</pre> -->
              {{questionMasterIndex + 1}}. <i>This Question is not available in the current language selected.</i>
            </td>

          </ng-template>



          <ng-container *ngFor="let client of insuredClientList; let i=index">
            <td
              *ngIf="questionnaireMap && questionnaireMap[client.id] && questionnaireMap[client.id].appliesToCd == 'CLIENT' && ((questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'] &&
              !!!questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd) || (questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'] &&
                  questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd &&
                  questionnaireMap[client.id]['questionnaireDtlsMap'][questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd] &&
                  questionnaireMap[client.id]['questionnaireDtlsMap'][questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd].responseCd == questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuesResponseCd))">
              <!-- {{questionMasterDO.questionCd}}
                {{questionnaireMap[client.id]['questionnaireDtlsMap'] | json}} -->
              <!-- Check if Required Objects exist -->
              <ng-container
                *ngIf="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd] &&
                questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO']; else noQuestionForClient">

                <!-- Check if Question is Valid or not -->
                <!-- *ngIf="!!!(questionMasterDO.leadingQuestionCd && questionMasterDO.isSubQuestionVisible)" -->
                <ng-container
                  *ngIf="(questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'] &&
                  !!!questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd)">
                  <!-- <pre>{{questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd] | json}}</pre> -->

                  <span
                    [ngSwitch]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].responseTypeCd">
                    <div *ngSwitchCase="'TEXT'">
                      <input nz-input class="quest-input-width" nzSize="small"
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)"
                        placeholder="Enter answer" />
                    </div>
                    <div *ngSwitchCase="'NUMERIC'">
                      <nz-input-number class="quest-input-width" nzSize="small"
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)"
                        placeholder="Enter answer" [nzStep]="1"></nz-input-number>
                    </div>
                    <div *ngSwitchCase="'LOOKUP'">
                      <nz-select nzShowSearch class="quest-input-width d-b" nzSize="small" nzAllowClear
                        nzPlaceHolder="Choose"
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)">
                        <nz-option
                          *ngFor="let item of (lookupData[questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].resLookupCd] || []);"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </nz-select>
                    </div>
                    <div *ngSwitchCase="'DATE'">
                      <nz-date-picker class="quest-input-width d-b" nzSize="small" nzAllowClear [nzShowTime]="false" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)" [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd">
                      </nz-date-picker>
                    </div>
                    <div *ngSwitchCase="'RADIO'">
                      <nz-radio-group
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)"
                        nzName="radiogroup" class="quest-input-width d-b">
                        <label
                          *ngFor="let item of (lookupData[questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].resLookupCd] || []);"
                          nz-radio [nzValue]="item?.lookupKey">{{item?.lookupValue}}</label>
                      </nz-radio-group>
                    </div>
                    <div *ngSwitchDefault>
                      Input Type expected for this question is currently not supported.
                    </div>
                  </span>
                  <!--<br />-->
                  <ng-container
                    *ngIf="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].captureDtlForResCd == 'YES'">
                    <textarea nz-input nzSize="small" placeholder="Remarks ..." class="quest-input-width"
                      [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseDtl"></textarea>
                  </ng-container>
                </ng-container>
                <ng-container
                  *ngIf="(questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'] &&
                  questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd &&
                  questionnaireMap[client.id]['questionnaireDtlsMap'][questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd] &&
                  questionnaireMap[client.id]['questionnaireDtlsMap'][questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd].responseCd == questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuesResponseCd)">
                  <!-- <pre>{{questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd] | json}}</pre> -->

                  <span
                    [ngSwitch]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].responseTypeCd">
                    <div *ngSwitchCase="'TEXT'">
                      <input nz-input class="quest-input-width" nzSize="small"
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)"
                        placeholder="Enter answer" />
                    </div>
                    <div *ngSwitchCase="'NUMERIC'">
                      <nz-input-number class="quest-input-width" nzSize="small"
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)"
                        placeholder="Enter answer" [nzStep]="1"></nz-input-number>
                    </div>
                    <div *ngSwitchCase="'LOOKUP'">
                      <nz-select nzShowSearch class="quest-input-width d-b" nzSize="small" nzAllowClear
                        nzPlaceHolder="Choose"
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)">
                        <nz-option
                          *ngFor="let item of (lookupData[questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].resLookupCd] || []);"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </nz-select>
                    </div>
                    <div *ngSwitchCase="'DATE'">
                      <nz-date-picker class="quest-input-width d-b" nzSize="small" nzAllowClear [nzShowTime]="false" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)" [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd">
                      </nz-date-picker>
                    </div>
                    <div *ngSwitchCase="'RADIO'">
                      <nz-radio-group
                        [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd" (ngModelChange)="setLeadingFlagForQuestion(questionMasterDO.questionCd,questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd)"
                        nzName="radiogroup" class="quest-input-width d-b">
                        <label
                          *ngFor="let item of (lookupData[questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].resLookupCd] || []);"
                          nz-radio [nzValue]="item?.lookupKey">{{item?.lookupValue}}</label>
                      </nz-radio-group>
                    </div>
                    <div *ngSwitchDefault>
                      Input Type expected for this question is currently not supported.
                    </div>
                  </span>
                  <!--<br />-->
                  <ng-container
                    *ngIf="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].captureDtlForResCd == 'YES'">
                    <textarea nz-input nzSize="small" placeholder="Remarks ..." class="quest-input-width"
                      [(ngModel)]="questionnaireMap[client.id]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseDtl" ></textarea>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #noQuestionForClient>
                <!--This question is not applicable for the insured.--> <i class="not-applicable">N.A</i>
              </ng-template>
              <ng-template #questionnaireDtlsMapNoQuestionCd>
                QuestionCd missing in questionnaireDtlsMap
              </ng-template>
              <ng-template #QuestionMasterDOMissing>
                Question MasterDO Missing
              </ng-template>
            </td>
          </ng-container>
        </tr>

        <!-- <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">1 a. Duration </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="i%2" nz-input placeholder="in years" class="quest-input-width" />
            <ng-container *ngIf="!(i%2)">N/A</ng-container>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">1 b. Medication </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="i%2" nz-input placeholder="" class="quest-input-width" />
            <ng-container *ngIf="!(i%2)">N/A</ng-container>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">1 c. Dosage </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="i%2" nz-input placeholder="" class="quest-input-width" />
            <ng-container *ngIf="!(i%2)">N/A</ng-container>
          </td>
        </tr> -->

        <!-- -------------------------------------------- -->

      </ng-container>



      <ng-container *ngIf="false">
        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">1. Do you smoke?</td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="isSmoker" [ngModel]="i%2">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">2. What is your height?(cms) </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input nz-input placeholder="in cms" class="quest-input-width" />
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">3. Have you ever had child-birth related disorders? </td>
          <ng-container *ngFor="let client of insuredClientList; let i=index">

            <td *ngIf="i%2">
              <span class="disabled">N/A</span>
            </td>
            <td *ngIf="!(i%2)">
              <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
              <nz-select nzShowSearch class="quest-input-width d-b" nzAllowClear nzPlaceHolder="Choose" ngModel="pre">
                <nz-option nzValue="eco" nzLabel="Ectopic"></nz-option>
                <nz-option nzValue="pre" nzLabel="Pre-term labor"></nz-option>
              </nz-select>
            </td>
          </ng-container>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">4. Have you ever had any of the following conditions?</td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <!-- Leave blank -->
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 a. Stroke, transient ischaemic attack (TIA), brain haemorrhage, brain aneurysm or other brain related
            injuries?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 b. Chest Pain, Angio, heart attack, heart enlargement, heart failure or any other heart conditon?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" />
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 c. Peripheral vascular or any disease or disorder of the aorta or arteries?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 d. Asthama, bronchitis, pneumonia, tuberculosis, emphysems or any other breating / lung disorder?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">
            5. Are you currently serving in the Armed Forces, or planning to in the future?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
        </tr>
      </ng-container>


    </tbody>

  </nz-table>
  <!-- <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="!questionnaireMap">
    xxx
  </nz-skeleton> -->

  <ng-container *ngIf="false && !environment.production">
    **Dev Logs**

    questionnaireMap
    <pre>
      {{questionnaireMap | json}}
    </pre>
    ----------------------------------------------------------------------------------------
    <br>
    <br>
    insuredClientList
    <pre>
      {{insuredClientList | json}}
    </pre>
    ----------------------------------------------------------------------------------------
    <br>
    <br>
    listOfQuestionMasterCds
    <pre>
      {{listOfQuestionMasterCds | json}}
    </pre>

  </ng-container>

</div>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="search-box" style="margin-right:-18em;">
    <input type="text" nz-input placeholder="Search Question" [(ngModel)]="questionSearch" style="width: 20em;"/><br>
  
    <div style="display: flex;">
      <button nz-button nzSize="small" nzType="primary" (click)="searchTableData(questionSearch)" class="search-button" style="flex: 1;">
      Search
      </button>
      <button nz-button nzSize="small" (click)="reset()" style="flex: 1;">
      Reset
      </button>
    </div>
  </div>
  
</nz-dropdown-menu>
<app-generic-zero-ui id="appGenericComponent" [list]="_questionnaire" icon="file-search" [title]="'Questionnaire not yet generated'"
  [message]="'Questionnaire will be generated, once you save the transaction'" [icon]="'exclamation-circle'">
</app-generic-zero-ui>